import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { HttpClientAdapter } from '../../domain/adapters/http.adapter';

export function provideApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: HttpClientAdapter, useClass: ApiHttpService },
  ]);
}
